
import axios from "axios";
import { getCsrfTokenFromCookie } from "core/utils/csrf";
import { 
  getCommentsResponseMapper,
  getCasesMetricsMapper
} from "core/mappers/common";
import { API_ENDPOINT } from "core/utils/constants";
import { t } from "i18next";
import { convertUnixTimeToDate } from  "core/utils/dateTimeUtils";
import { Toast as showToast } from "core/components/global/toast/toast";
import { fetchBaseUrl } from "core/utils/common";
import { AlertSummarySchema } from "../components/ac2Alerts/alertSummary/alertSummary";


const baseURL = `${fetchBaseUrl({port: 8002})}/ac2/ui`;
const baseURLApi = `${fetchBaseUrl({port: 8001})}/ac2/api`;

export const getAlertDetailsByIdService = async (config, id: string) => {  
  // Fetch the alert by ID
  try {
    // Encode the ID parameter to handle special characters
    const req_response = await axios.request({
      method: 'GET',
      url: `${baseURL}/alerts?id=${id}`,
      headers: config
    });

    if (req_response.status > 299) {
      console.error("Error occurred while fetching getAlertDetailsByIdService:", req_response.status);
      return false;
    } else {
      /*
      Data has been recieved successfully from the tables but now we must clean the data ready
      for the JSX to convert/prettify for human consumption. 
      */
      // Extract the response data
      const data = req_response.data;
    
      // Convert the comment postedOn from timestamp to a human readable date
      const comments = data["comments"].map(comment => ({
        ...comment,
        postedOn: convertUnixTimeToDate(comment.postedOn)
      }));

      // TODO This data can be enhanced with Regex, for now it is fine to enbolden a few titles we know will exist
      let aws_best_practices = data["aws_best_practices"];
      if(aws_best_practices){
      aws_best_practices = aws_best_practices.replace(
        /Summary:/g, 
        '<strong className="mt-2">Summary:</strong>'
      );
      aws_best_practices = aws_best_practices.replace(
        /Overview:/g, 
        '<strong className="mt-2">Overview:</strong>'
      );
      aws_best_practices = aws_best_practices.replace(
        /Analysis:/g, 
        '<strong className="mt-2">Analysis:</strong>'
      );
    }

      // There are many subtitles that need to be enboldened, TODO this could use some enhancement to put each new title one level in and an indent further in
      let description =  data["summary"];
      if(description){
      description = description.replace(
        /Controls Summary:/g, 
        '<span className="mt-2"><strong>Controls Summary:</strong></span>'
      );
      description = description.replace(
        /Summary:/g, 
        '<span className="mt-2"><strong>Summary:</strong></span>'
      );
      description = description.replace(
        /Notes:/g, 
        '<span className="mt-2"><strong>Notes:</strong></span>'
      );
    }

      // TODO This data can be enhanced with Regex, for now it is fine to enbolden a few titles we know will exist
      let cloudformation = data["cloud_formation"];
      if(cloudformation){
      cloudformation = cloudformation.replace(
        /Here's the CloudFormation template to remediate these issues:/g, 
        "<strong className='mt-2'>Here's the CloudFormation template to remediate these issues:</strong>"
      );
      cloudformation = cloudformation.replace(
        /Explanation of the template:/g, 
        '<strong className="mt-2">Explanation of the template:</strong>'
      );
      cloudformation = cloudformation.replace(
        /How to use the template:/g, 
        '<strong className="mt-2">How to use the template:</strong>'
      );
      cloudformation = cloudformation.replace(
        /Prerequisites:/g, 
        '<strong className="mt-2">Prerequisites:</strong>'
      );
      cloudformation = cloudformation.replace(
        /Parameters to set:/g, 
        '<strong className="mt-2">Parameters to set:</strong>'
      );
      cloudformation = cloudformation.replace(
        /Deployment:/g, 
        '<strong className="mt-2">Deployment:</strong>'
      );
      cloudformation = cloudformation.replace(
        /Post-deployment:/g, 
        '<strong className="mt-2">Post-deployment:</strong>'
      );
      cloudformation = cloudformation.replace(
        /Note:/g, 
        '<strong className="mt-2">Note:</strong>'
      );
    }
      // TODO This data can be enhanced with Regex, for now it is fine to enbolden a few titles we know will exist
      let terraform = data["terraform_remediation"];
      if(terraform){
      terraform = terraform.replace(
        /This Terraform code will:/g, 
        "<strong className='mt-2 mb-2'>This Terraform code will:</strong>"
      );
      terraform = terraform.replace(
        /Here's the Terraform code to achieve this:/g, 
        "<strong className='mt-2 mb-2'>Here's the Terraform code to achieve this:</strong>"
      );
      terraform = terraform.replace(
        /Here's the Terraform code to implement these changes:/g, 
        "<strong className='mt-2 mb-2'>Here's the Terraform code to achieve this:</strong>"
      );
      terraform = terraform.replace(
        /Explanation of the Terraform code:/g, 
        "<strong className='mt-2 mb-2'>Explanation of the Terraform code:</strong>"
      );
      terraform = terraform.replace(
        /To use this Terraform configuration:/g, 
        "<strong className='mt-2 mb-2'>To use this Terraform configuration:</strong>"
      );
      terraform = terraform.replace(
        /This Terraform configuration does the following:/g, 
        "<strong className='mt-2 mb-2'>This Terraform configuration does the following:</strong>"
      );
      terraform = terraform.replace(
        /Prerequisites:/g, 
        "<strong className='mt-2 mb-2'>Prerequisites:</strong>"
      );
      terraform = terraform.replace(
        /How to use this Terraform configuration:/g, 
        "<strong className='mt-2 mb-2'>How to use this Terraform configuration:</strong>"
      );
      terraform = terraform.replace(
        /Usage:/g, 
        "<strong className='mt-2 mb-2'>Usage:</strong>"
      );
      terraform = terraform.replace(
        /Customization:/g, 
        "<strong className='mt-2 mb-2'>Customization:</strong>"
      );
      terraform = terraform.replace(
        /Variables:/g, 
        "<strong className='mt-2 mb-2'>Variables:</strong>"
      );
      terraform = terraform.replace(
        /Monitoring:/g, 
        "<strong className='mt-2 mb-2'>Monitoring:</strong>"
      );
      terraform = terraform.replace(
        /Note:/g, 
        "<strong className='mt-2 mb-2'>Note:</strong>"
      );
    }
      // Here we prepare the CLI to be presented as propperly formatted JSON with the suffix of information and the command itself
      let policyString = data["aws_cli_remediation"];
      if(policyString){
      try {
        const jsonStart = policyString.indexOf('{'); 
        const stringStart = policyString.substring(0, jsonStart); 
        const jsonEnd = policyString.lastIndexOf('}') + 1; 
        const jsonString = policyString.substring(jsonStart, jsonEnd); 
        policyString = JSON.parse(jsonString);
        policyString = stringStart + "'" + JSON.stringify(policyString, null, 2) + "'"
      } catch (error) {
        // Do nothing lets just use the raw policyString, lets prettify what we can
      }
    }

      // Remove the answer enclosing tags from the standards mapping, we don't need them
      const stripAnswerTags = (input) => input&&input.replace(/<\/?answer>/g, '');
      
      // Build the response to feed the AlertSummary component
      const response = {
        'id': data["alertid"],
        'severity': data["severity"],
        'status': data["status"],
        'classification': data["classification"],
        'organization': data["org"],
        'assignedUsers':  [data["assignedto"]],
        'findingid': data["findingid"],
        'tags': "tags" in data ? data["tags"] :  [],
        'comments': "comments" in data ? comments :  [],
        'relatedAlerts': [],
        'createdDate': convertUnixTimeToDate(data["createddate"]),
        'lastModified': convertUnixTimeToDate(data["lastmodified"]),
        'description': description,
        'awsBestPractice': aws_best_practices,
        'terraformRemediation': terraform,
        'awsCliRemediation': policyString,
        'cloudformationTemplate': cloudformation,
        'standardMapping': stripAnswerTags(data["standards_mapping"]),
      }
      
      console.log('Returning formatted response:', response);
      return response;
    }
  } catch (error) {
    console.error("Error occurred while fetching getAlertDetailsByIdService:", error)
    return false;
  }
}

export const refetchAlertDetailsByIdService = async (token: string, id: string, updateCallback?: (mappedData: any) => void) => {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await fetch(`${baseURLApi}/task/datalake_process_task?stream=true`, {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'X-API-Key': token,
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({
        user_input: id,
        conversation_id: "",
        parameters: {},
        scope: "string"
      })
    });

    if (!response.ok || !response.body) {
      throw new Error("Failed to fetch alert details");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let chunks = '';
    let mapped: { [key: string]: string } = {};
    // Initialize with the ID to ensure we always have this value
    mapped.id = id;

    // Each chunk is a JSON string, accumulate and parse
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      chunks += decoder.decode(value, { stream: true });

      // Try to parse each chunk as JSON object
      // If your backend sends multiple JSON objects, split by newline or use a streaming JSON parser
      const lines = chunks.split('\n').filter(Boolean);
      for (const line of lines) {
        console.log(`Received line: ${JSON.stringify(line)}`);
       // Handle plain text error
        if (line.includes("No such alert")) {
          mapped.error = line;
          if (updateCallback) updateCallback({ ...mapped });
          // Optionally, break out of the loop early
          return {
            id,
            error: line,
            description: "",
            standardMapping: "",
            awsBestPractice: "",
            terraformRemediation: "",
            awsCliRemediation: "",
            cloudformationTemplate: "",
            severity: "",
            status: "",
            classification: "",
            organization: "",
            assignedUsers: [],
            createdDate: "",
            lastModified: "",
            comments: [],
            findingid: "",
            tags: [],
            relatedAlerts: [],
            viewStatus:"notfound"
          };
        }

        // Try to parse as JSON
        let obj: any = null;
        try {
          obj = JSON.parse(line);
        } catch {
          continue; // Not JSON, skip
        }

        // Handle JSON error step
        if (obj && obj.step === "error") {
          mapped.error = obj.error || "Unknown error";
          if (updateCallback) updateCallback({ ...mapped });
          return {
            id,
            error: mapped.error,
            description: "",
            standardMapping: "",
            awsBestPractice: "",
            terraformRemediation: "",
            awsCliRemediation: "",
            cloudformationTemplate: "",
            severity: "",
            status: "",
            classification: "",
            organization: "",
            assignedUsers: [],
            createdDate: "",
            lastModified: "",
            comments: [],
            findingid: "",
            tags: [],
            relatedAlerts: [],
            viewStatus:"notfound"
          };
        }

        // ...existing step handling...
        if (obj && obj.step === 'alert_summarization') {
          mapped.description = obj.summary || '';
          if (updateCallback) updateCallback({ ...mapped });
        }
        if (obj && obj.step === 'gap_analysis') {
          mapped.standardMapping = obj.gap_analysis || '';
          if (updateCallback) updateCallback({ ...mapped });
        }
        if (obj && obj.step === 'cli_remediation') {
          mapped.awsCliRemediation = obj.cli_remediation || '';
          if (updateCallback) updateCallback({ ...mapped });
        }
        if (obj && obj.step === 'cloud_best_practices') {
          mapped.awsBestPractice = obj.cloud_best_practices || '';
          if (updateCallback) updateCallback({ ...mapped });
        }
        if (obj && obj.step === 'cloud_formation') {
          mapped.cloudformationTemplate = obj.cloud_formation || '';
          if (updateCallback) updateCallback({ ...mapped });
        }
        if (obj && obj.step === 'terraform_remediation') {
          mapped.terraformRemediation = obj.terraform_remediation || '';
          if (updateCallback) updateCallback({ ...mapped });
        }
      }
      chunks = '';
    }

    // Build the final response object (add other fields as needed)
    // Example mapping for the final response object
      const responseObj: AlertSummarySchema = {
        id: id,
        severity: mapped.severity || "",
        status: mapped.status || "",
        classification: mapped.classification || "",
        organization: mapped.organization || "",
        assignedUsers: Array.isArray(mapped.assignedUsers)
          ? mapped.assignedUsers
          : typeof mapped.assignedUsers === "string"
            ? [mapped.assignedUsers]
            : [],
        description: mapped.description || "",
        standardMapping: mapped.standardMapping || "",
        awsBestPractice: mapped.awsBestPractice || "",
        terraformRemediation: mapped.terraformRemediation || "",
        awsCliRemediation: mapped.awsCliRemediation || "",
        cloudformationTemplate: mapped.cloudformationTemplate || "",
        createdDate: mapped.createdDate || "",
        lastModified: mapped.lastModified || "",
        comments: Array.isArray(mapped.comments) ? mapped.comments : [],
        findingid: mapped.findingid || "",
        tags: Array.isArray(mapped.tags)
          ? mapped.tags
          : typeof mapped.tags === "string"
            ? [mapped.tags]
            : [],
        relatedAlerts: Array.isArray(mapped.relatedAlerts)
          ? mapped.relatedAlerts
          : typeof mapped.relatedAlerts === "string"
            ? [mapped.relatedAlerts]
            : [],
            viewStatus: "fetched"
      };
    return responseObj;
  } catch (error) {
    console.error("Error occurred while fetching getAlertDetailsByIdService:", error);
    return   {
            id,
            error:error,
            description: "",
            standardMapping: "",
            awsBestPractice: "",
            terraformRemediation: "",
            awsCliRemediation: "",
            cloudformationTemplate: "",
            severity: "",
            status: "",
            classification: "",
            organization: "",
            assignedUsers: [],
            createdDate: "",
            lastModified: "",
            comments: [],
            findingid: "",
            tags: [],
            relatedAlerts: [],
            viewStatus:"notfound"
          };
  }
}

/**
 * Allows a user to add a comment to an alert
 * @param comment 
 * @param id 
 * @returns 
 */
export const postUserComment = async (config, comment, id) => {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const req_response = await axios.request({
      method: 'POST',
      url: `${baseURL}/alerts/${id}/comments`,
      headers: { ...config, 'X-CSRF-Token': csrfToken },
      data : comment
    })

    if (req_response.status > 299) {
      showToast(`Unable to add comments for alert ${id} with status ${req_response.status}`, "error");
    } else {
      return(req_response)
    }
  } catch (error) {
    showToast(`Unable to add comments for alert ${id}`, "error");
  }
}

/**
 * Get the summary for the standard
 * @param config 
 * @param comment 
 * @param id 
 * @returns 
 */
export const getStandardDetails = async (config, standard, id) => {
  try {
    const req_response = await axios.request({
      method: 'GET',
      url: `${baseURL}/alerts/${id}/standards?standard=${standard}`,
      headers: config
    })

    if (req_response.status > 299) {
      showToast(`Unable to fetch the summary for standard ${standard} with status ${req_response.status}`, "error");
    } else {
      return(req_response)
    }
  } catch (error) {
    showToast(`Unable to fetch the summary for standard ${standard}`, "error");
  }
}

/**
 * Retrieves all comments for an alert
 * @param comment 
 * @param id 
 * @returns 
 */
export const getAlertComments = async (config, id) => {
  try {
    const req_response = await axios.request({
      method: 'GET',
      url: `${baseURL}/alerts/${id}/comments`,
      headers: config
    })

    if (req_response.status > 299) {
      // showToast(`Unable to fetch comments for alert ${id} with status ${req_response.status}`, "error");
    } else {
      const data = await req_response.data;
      return getCommentsResponseMapper(t, data);
    }
  } catch (error) {
    // showToast(`Unable to fetch comments for alert ${id}`, "error");
  }
}


/**
 * Below this point are all the original user functions but we are not currently
 * using many of the mechanics, e.g. companies or organizations plural
 */
export async function getAlertsRequestRecursion(config, pageSize, offset, newestStateEventTs = 0) {
  let url = `${baseURL}/alerts`;
  url += `?size=${pageSize}`;
  url += `&offset=${offset}`;
  url += `&newestStateEventTs=${newestStateEventTs}`;

  try {
    const response = await axios.request({
      method: 'GET',
      url: url,
      headers: config,
    });
    
    if (response.status > 299) {
      showToast(`Error fetching records from offset ${offset} and after timestamp ${newestStateEventTs}`, "error");
    } else {
      return response;
    }
  } catch (error) {
    showToast(`Unable to fetch records from offset ${offset} and after timestamp ${newestStateEventTs}`, "error");
  }
}


export async function getAlertsUpdatesRequestRecursion(config, lastUpdatedTs = 0) {
  let url = `${baseURL}/alerts`;
  url += `?lastUpdatedTs=${lastUpdatedTs}`;

  const response = await axios.request({
    method: 'GET',
    url: url,
    headers: config,
  });

  return response;
}


/**
 * Allows a user to assign themselves or another to an alert
 * @param email 
 * @returns 
 */
export const assignAlertRequestService = async (email, id, config) => {
  const csrfToken = getCsrfTokenFromCookie();
  const response = await axios.request({
    method: 'PUT',
    url: `${baseURL}/alerts/${id}/assigned`,
    headers: { ...config, 'X-CSRF-Token': csrfToken },
    data: { "email": email }
  });
  
  return response;
};

export const setAlertStatusRequestService = async (status, id, config) => {
  const csrfToken = getCsrfTokenFromCookie();
  const response = await axios.request({
    method: 'PUT',
    url: `${baseURL}/alerts/${id}/status`,
    headers: { ...config, 'X-CSRF-Token': csrfToken },
    data: { "status": status }
  });
  
  return response;
};


/**
 * Retrieves all comments for an incident
 * @param comment 
 * @param id 
 * @returns 
 */
export const getAlertFilters = async (config) => {
  try {
    const req_response = await axios.request({
      method: 'GET',
      url: `${baseURL}/alerts/filters`,
      headers: config
    })

    if (req_response.status > 299) {
      // console.error(`Unable to fetch finding filter`)
      showToast(`Unable to fetch finding filters`, "error");
    } else {
      const data = await req_response.data;
      return(data);
    }
  } catch (error) {
    showToast(`Unable to fetch finding filters`, "error");
  }
}

let savedFilters: any = null;

export const saveIncidentFilters = async (filterData: any) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      savedFilters = filterData;
      resolve(savedFilters);
    }, 500); 
  });
};

/**
 * Retrieves all comments for an incident
 * @param comment 
 * @param id 
 * @returns 
 */
export const getHomeMetrics = async (config) => {
  try {
    const req_response = await axios.request({
      method: 'GET',
      url: `${baseURL}/alerts/metrics/home`,
      headers: config
    })

    if (req_response.status > 299) {
      // console.error(`Unable to fetch metrics for home`)
      showToast(`Unable to fetch metrics for home`, "error");
    } else {
      const data = await req_response.data;
      return(data);
    }
  } catch (error) {
    showToast(`Unable to fetch metrics for home`, "error");
  }
}

/**
 * Retrieves all comments for an incident
 * @param comment 
 * @param id 
 * @returns 
 */
export const getCasesMetrics = async (config) => {
  try {
    const req_response = await axios.request({
      method: 'GET',
      url: `${baseURL}/alerts/metrics/cases`,
      headers: config
    })

    if (req_response.status > 299) {
      showToast(`Unable to fetch metrics for cases`, "error");
    } else {
      const data = await req_response.data;
      return(getCasesMetricsMapper(t, data));
    }
  } catch (error) {
    showToast(`Unable to fetch metrics for cases`, "error");
  }
}

/**
 * Retrieves all comments for an incident
 * @param comment 
 * @param id 
 * @returns 
 */
export const getAlertsByPage = async (config, size, page, order, orderBy, filters, search) => {
  try {
    const merged_params = {...filters, ...{
      'size': size,
      'page': page,
      'order': order,
      'orderBy': orderBy
    }}

    if (search !== "") {
      merged_params["search"] = search
    }

    const req_response = await axios.request({
      method: 'GET',
      url: `${baseURL}/alerts`,
      headers: config,
      params: merged_params
    })

    if (req_response.status > 299) {
      // console.error(`Unable to fetch findings by page`)
      showToast(`Unable to fetch findings by page`, "error");
    } else {
      const data = await req_response;
      return data;
    }
  } catch (error) {
    // console.error(`getAlertsByPage error: ${JSON.stringify(error)}`)
    showToast(`Unable to fetch findings by page`, "error");
  }
}


/**
 * Gets all incidents assigned to a user
 * @param email 
 * @returns 
 */
export const getAlertsByEmailServiceApi = async (config, email: string) => {
  try {
    const req_response = await axios.request({
      method: 'GET',
      url: `${baseURL}/${API_ENDPOINT.IDM_USERS}/${email}/alerts`,
      headers: config
    });

    if (req_response.status > 299) {
      showToast(`Unable to fetch findings for ${email}`, "error");
      return false;
    } else {
      const data = await req_response.data;
      return getAlertsByEmailServiceApi(t, data);
    } 
  } catch (error) {
    // console.error(`getAlertsByEmailServiceApi error: ${JSON.stringify(error)}`)
    showToast(`Unable to fetch findings for ${email}`, "error");
    return false;
  }
}


/**
 * Gets all Frameworks Metrics
 * @param email 
 * @returns 
 */
export const getConformanceMetrics = async (config) => {
  try {
    const req_response = await axios.request({
      method: 'GET',
      url: `${baseURL}/alerts/metrics/compliance-by-framework`,
      headers: config
    });

    if (req_response.status > 299) {
      showToast(`Unable to fetch Framework metrics`, "error");
      return false;
    } else {
      return req_response;
    }
  } catch (error) {
    // console.error(`getConformanceMetrics error: ${JSON.stringify(error)}`)
    showToast(`Unable to fetch Framework metrics`, "error");
    return false;
  }
}